import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isLoggedOnSelector } from '../selectors/isLoggedOnSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { refreshExternalCasesAtom } from '../atoms/refreshExternalCasesAtom';
import { refreshCustomerBenefitsAtom } from '../atoms/refreshCustomerBenefitsAtom';

export const useRemoveCoverable = (): {
    removeCoverable: (linePrefix: string, fixedId: string) => Promise<void>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);
    const refreshExternalCases = useSetRecoilState(refreshExternalCasesAtom);
    const refreshCustomerBenefits = useSetRecoilState(refreshCustomerBenefitsAtom);

    const removeCoverable = async (linePrefix: string, fixedId: string): Promise<void> => {
        await OnlineSalesUnauthenticated.removeCoverableFromShoppingBasket(
            jobNumber,
            sessionId,
            linePrefix,
            fixedId,
            !isLoggedOn
        );
        refreshExternalCases({});
        refreshCustomerBenefits({});
    };

    return { removeCoverable };
};
